// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import EitherController from "./either_controller.js"
application.register("either", EitherController)

import SelectorContoller from "./selector_controller.js"
application.register("selector", SelectorContoller)

import StripeContoller from "./stripe_controller.js"
application.register("stripe", StripeContoller)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import XhrFormController from "./xhr_form_controller.js"
application.register("xhr-form", XhrFormController)
